<template>
    <v-dialog v-model="dialog"
        fullscreen hide-overlay transition="dialog-bottom-transition"
    >
        <v-card tile class="grey darken-3">
            <v-toolbar dense color="blue-grey darken-2" max-height="48px">
                <v-toolbar-title>Bericht: {{ report.name }}</v-toolbar-title>
                <!-- <v-text-field flat solo dense hide-details background-color="blue-grey darken-3" :prefix="prefix" readonly
                    :value="report.name"
                ></v-text-field>   -->
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="onReload">
                    <v-icon>mdi-reload</v-icon>
                </v-btn> -->
			    <v-btn small class="ml-3" :disabled="dirty && !dirty" color="blue darken-4" @click.stop="onAddItem()">Hinzufügen</v-btn>
			    <v-btn small class="ml-3" :disabled="!dirty" color="green darken-4" @click.stop="onSaveItems()">Speichern</v-btn>
                <v-btn small class="ml-3" v-if="dirty" color="orange darken-1" @click.stop="onCancel()">Abbrechen</v-btn>
			    <v-btn small class="ml-3" v-else color="blue-grey darken-4" @click.stop="onCancel()">Schliessen</v-btn>
            </v-toolbar>
				<v-tabs v-model="htab" background-color="blue-grey darken-3" color="grey" active-class="blue-grey darken-1 black--text"
					align-with-title
					slider-color="blue-grey darken-1"
					dark dense height="35px"
					next-icon="mdi-arrow-right-bold-box-outline"
					prev-icon="mdi-arrow-left-bold-box-outline"
					show-arrows show-arrows-on-hover center-active
				>
					<v-tab v-for="(item, hindex) in days" :key="hindex" height="35px">
						{{ item.name }}
					</v-tab>
				</v-tabs>
                <v-tabs-items v-model="htab" />
            <v-card-text class="ma-0 pa-0" style="xheight: 520px;"><v-form autocomplete="off">
   <v-simple-table dense fixed-header :height="(winHeight - 137) + 'px'" class="grey darken-3">
      <template v-slot:default class="grey darken-3">
        <thead>
          <tr>
            <th class="text-left grey darken-3">Nr</th>
            <th class="text-left grey darken-3">Leistung</th>
            <th class="text-left grey darken-3">*</th>
            <th class="text-left grey darken-3">Menge</th>
            <th class="text-left grey darken-3">Menge Klfl.</th>
            <th class="text-left grey darken-3">Betrag</th>
            <th class="text-left grey darken-3">Gesamt</th>
            <th class="text-left grey darken-3">*</th>
          </tr>
        </thead>
        <tbody>
            <tr v-for="item in items" :key="item.name" class="ma-0 pa-0 px-0">
                <td class="ma-0 pa-0 pt-1 pl-1" width="75px">
                <v-text-field v-model="item.tsknr" label="" hide-details dense placeholder="" solo spellcheck="false" readonly
                    class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="300px">
                <v-text-field v-model="item.tskname" label="" hide-details dense placeholder="" solo spellcheck="false" readonly
                    class="ma-0 pa-0" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="20px">
                    <v-btn v-if="item.canedit" :disabled="dirty" icon @click="onEditItem(item)"><v-icon color="green darken-1">create</v-icon></v-btn>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="150px">
                <v-fab-transition mode="out-in">
                    <DecInput v-if="htab==htab" :day="(htab + 1)" :refname="'amount' + (htab + 1) + '_ref'" :prefix="(item.comp || '-') + ' € / ' + item.unit"
                        :value="item['amount' + (htab + 1)]" @changed="onUpdate(item.id, 'amount' + (htab + 1), $event)" />                    
                    <!-- <v-text-field v-if="htab==htab" v-model="item['amount' + (htab + 1)]" label="" hide-details dense placeholder="Mo" solo :key="(htab + 1)"
                        class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                        :prefix="item.comp + ' € / ' + item.unit" @blur="onBlur" @change="onChange" @input="onInput"
                    ></v-text-field> -->
                </v-fab-transition>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="150px">
                <v-fab-transition mode="out-in">
                    <DecInput v-if="htab==htab" :day="(htab + 1)" :refname="'amount' + (htab + 1) + 'k' + '_ref'" :prefix="(item.compk || '-') + ' € / ' + item.unit"
                        :value="item['amount' + (htab + 1) + 'k']" @changed="onUpdate(item.id, 'amount' + (htab + 1) + 'k', $event)" />                    
                    <!-- <v-text-field v-if="htab==htab" v-model="item['amount' + (htab + 1) + 'k']" label="" hide-details dense placeholder="Mo" solo :key="(htab + 1)"
                        class="ma-0 pa-0 textfield right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
                        :prefix="(item.compk || '-') + ' € / ' + item.unit" @blur="onBlur" @change="onChange" @input="onInput"
                    ></v-text-field> -->
                </v-fab-transition>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="70px">
                    <v-fab-transition mode="out-in">
                        <DecView v-if="htab==htab" :day="(htab + 1)" :value="item['sum' + (htab + 1)]" />                    
                        <!-- <v-text-field v-if="htab==htab" v-model="item['sum' + (htab + 1)]" label="" hide-details dense placeholder="" solo readonly :key="(htab + 1)"
                            class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field> -->
                    </v-fab-transition>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="70px">
                    <DecView :value="item.total" />                    
                    <!-- <v-text-field v-model="item.total" label="" hide-details dense placeholder="" solo spellcheck="false" readonly
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field> -->
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="20px">
                    <v-btn v-if="!item.total" :disabled="item.id && dirty" icon @click="onDeleteItem(item)"><v-icon color="red darken-1">delete</v-icon></v-btn>
                </td>
            </tr>
            <tr>
                <td colspan="4"></td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="70px">
                    <v-text-field value="Tages-/Wochensumme:" label="" hide-details dense placeholder="" solo spellcheck="false" readonly
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="70px">
                    <v-fab-transition mode="out-in">
                        <DecView v-if="htab==htab" :day="(htab + 1)" :value="daysum[(htab + 1)]" />                    
                        <!-- <v-text-field v-if="htab==htab" v-model="daysum[(htab + 1)]" label="" hide-details dense placeholder="" solo readonly :key="(htab + 1)"
                        class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field> -->
                    </v-fab-transition>
                </td>
                <td class="ma-0 pa-0 pt-1 pl-1" width="70px">
                    <DecView :value="totalsum" />                    
                    <!-- <v-text-field v-model="totalsum" label="" hide-details dense placeholder="" solo spellcheck="false" readonly
                    class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"></v-text-field> -->
                </td>
            </tr>
        </tbody>
      </template>
    </v-simple-table>
            </v-form></v-card-text>
            <v-divider />
            <v-card-actions>
            <!-- <v-btn text class="warning" @click="onCancel()">Abbrechen</v-btn> -->
            <v-spacer />
            </v-card-actions>
        </v-card>
        <Selector v-if="selector" label="Select Tasks" table="tasks" :existing="existing"
            @submit="onSelectorSubmit($event)" @cancel="onSelectorSubmit($event)" />
        <GenericForm v-if="edit" :modulData="modulData" @cancelled="editCancelled()" @submitted="editSubmitted()" />
        <v-dialog v-model="confirmation" width="500px">
            <v-toolbar dark color="orange darken-4" dense>
                <v-toolbar-title class="white--text">{{ message.title }}</v-toolbar-title>
            </v-toolbar>
            <v-card tile>
                <!-- <v-card-text color="red" v-html="message.msg"/> -->
                <v-card-actions>
                    <v-btn color="grey" text @click="onConfirmationClose('no')">Zurück</v-btn>
                    <v-spacer/>
                    <v-btn color="orange darken-4" @click="onConfirmationClose('yes')">Ja</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay absolute :value="loading">
        	<v-progress-circular indeterminate size="64" width="7" color="cyan darken-4"></v-progress-circular>
        </v-overlay>
    </v-dialog>
</template>

<script>
import DecInput from './DecInput'
import DecView from './DecView'
import Selector from './Selector'
import GenericForm from '../../generic/GenericForm'
export default {
    name: 'report',
    components: { DecInput, DecView, Selector, GenericForm },
    props: {
        specData: {
            type: Object,
            required: true,
            default: null,
        },
    },
    data: () => ({
        loading: false,
        dialog: false,
        selector: false,
        edit: false,
        modulData: {},
        search: '',
        htab: 0,
        winHeight: window.innerHeight,
        prefix: 'Bericht:',
        days: [
            { name: 'Mo'}, { name: 'Di'}, { name: 'Mi'}, { name: 'Do'}, { name: 'Fr'}, { name: 'Sa'}, { name: 'So'}, 
        ],
        items: [],
        existing: [],
        daysum: [0, 0, 0, 0, 0, 0, 0, 0],
        totalsum: 0,
        dirty: false,
        message: {},
        confirmation: false,
    }),
    computed: {
        report() {
            return this.specData.meta.model
        }
    },
    methods: {
        sortItems() {
            this.items.sort((a, b) => a.ntsknr - b.ntsknr)
        },
        async editData() {
            this.loading = true
            const param = {
                tablename: 'reports',
                subtable: 'repitems',
                data: this.report
            }
            try {
                await this.$store.dispatch('special/editSubItems', param)
                this.items = Object.assign([], this.$store.getters['special/getItem'])
                this.sortItems()
                this.calcSums()
                this.dirty = false
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
		async saveData() {
			this.loading = true
            this.report.repitems = this.items
			const param = {
                tablename: 'reports',
                subtable: 'repitems',
                data: this.report
			}
            try {
                await this.$store.dispatch('special/saveSubItems', param)
                this.items = Object.assign([], this.$store.getters['special/getItem'])
                this.sortItems()
                this.calcSums()
                this.dirty = false
        	} catch (error) {
                console.error(error)
				console.log(error.response)
            } finally {
                this.loading = false
            }
		},
        async deleteItem(item) {
            this.loading = true
            const param = {
                tablename: 'repitems',
                data: item
            }
            try {
                await this.$store.dispatch('special/delItem', param)
                this.items.splice(this.items.findIndex(e => e.id === item.id), 1)
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        calcSums() {
            this.items.map(e => e.amount = +e.amount1 + +e.amount2 + +e.amount3 + +e.amount4 + +e.amount5 + +e.amount6 + +e.amount7)
            this.items.map(e => e.amountk = +e.amount1k + +e.amount2k + +e.amount3k + +e.amount4k + +e.amount5k + +e.amount6k + +e.amount7k)
            this.items.map(e => e.sum1 = Number((e.amount1 * e.comp).toFixed(2)) + Number((e.amount1k * e.compk).toFixed(2)))
            this.items.map(e => e.sum2 = Number((e.amount2 * e.comp).toFixed(2)) + Number((e.amount2k * e.compk).toFixed(2)))
            this.items.map(e => e.sum3 = Number((e.amount3 * e.comp).toFixed(2)) + Number((e.amount3k * e.compk).toFixed(2)))
            this.items.map(e => e.sum4 = Number((e.amount4 * e.comp).toFixed(2)) + Number((e.amount4k * e.compk).toFixed(2)))
            this.items.map(e => e.sum5 = Number((e.amount5 * e.comp).toFixed(2)) + Number((e.amount5k * e.compk).toFixed(2)))
            this.items.map(e => e.sum6 = Number((e.amount6 * e.comp).toFixed(2)) + Number((e.amount6k * e.compk).toFixed(2)))
            this.items.map(e => e.sum7 = Number((e.amount7 * e.comp).toFixed(2)) + Number((e.amount7k * e.compk).toFixed(2)))
            this.items.map(e => e.total = e.sum1 + e.sum2 + e.sum3 + e.sum4 + e.sum5 + e.sum6 + e.sum7)
            this.daysum[1] = this.items.reduce(function(prev, cur) { return prev + cur.sum1; }, 0);
            this.daysum[2] = this.items.reduce(function(prev, cur) { return prev + cur.sum2; }, 0);
            this.daysum[3] = this.items.reduce(function(prev, cur) { return prev + cur.sum3; }, 0);
            this.daysum[4] = this.items.reduce(function(prev, cur) { return prev + cur.sum4; }, 0);
            this.daysum[5] = this.items.reduce(function(prev, cur) { return prev + cur.sum5; }, 0);
            this.daysum[6] = this.items.reduce(function(prev, cur) { return prev + cur.sum6; }, 0);
            this.daysum[7] = this.items.reduce(function(prev, cur) { return prev + cur.sum7; }, 0);
            this.totalsum = this.items.reduce(function(prev, cur) {
                return prev + cur.sum1 + cur.sum2 + cur.sum3 + cur.sum4 + cur.sum5 + cur.sum6 + cur.sum7;
            }, 0);
        },
        onReload() {
            this.editData()
        },
        onCancel() {
            if(!this.dirty) this.endDialog()
			this.message.title = 'Abbrechen - Änderungen verwerfen?'
			this.confirmation = true			
        },
        endDialog() {
            this.$emit('cancel')
            this.dialog = false
        },
        onUpdate(id, fieldName, newValue) {
            const idx = this.items.find(e => e.id === id)
            if(newValue === 0) newValue = null
            this.$set(idx, fieldName, newValue)
            /*console.log('idx:', idx)
            console.log('idx item:', this.items[idx])
            console.log('idx item field:', this.items[idx][fieldName])
            this.$set(this.items[idx], fieldName, newValue)*/
            this.calcSums()
            this.dirty = true
        },
        onBlur() {
        },
        onInput() {
        },
        onChange() {
            this.calcSums()
            this.dirty = true
            //console.log('changed:', this.totalsum)
        },
        onAddItem() {
            this.existing = Array.from(this.items, e => e.task_id)
            this.selector = true
            this.dirty = true
        },
        onSelectorSubmit(newItems) {
            if(Array.isArray(newItems)) {
                let self = this
                newItems.forEach(function(newItem){
                    self.items.push(
                        {
                            report_id: self.report.id,
                            task_id: newItem.id,
                            tsknr: newItem.tsknr,
                            ntsknr: newItem.ntsknr,
                            tskname: newItem.name,
                            comp: newItem.comp,
                            compk: newItem.compk,
                            unit: newItem.unit,
                            canedit: newItem.canedit,
                        }
                    )
                })
            }
            this.sortItems()
            this.dirty = true
            this.selector = false
            this.saveData()
            this.dirty = false
        },
		editCancelled () {
			this.edit = false
		},
		editSubmitted() {
            this.onReload()
			this.edit = false
		},
        onEditItem(item) {
            this.modulData = Object.assign({}, this.specData)
            //this.modulData = {...this.specData}
            //this.modulData = JSON.parse(JSON.stringify(this.specData))
            this.modulData.meta.subtable = 'repitems'
            const model = Object.assign({}, item)
            this.modulData.meta.model = model
			this.edit = true
        },
        onDeleteItem(item) {
            if(item.id) {
                this.deleteItem(item)
            } else {
                this.items.splice(this.items.findIndex(e => e.task_id === item.task_id), 1)
            }
        },
        onSaveItems() {
            this.saveData()
            this.dirty = false
        },
        onSubmit() {
            this.$emit('submit')
            this.dialog = false
        },
        handleResize() {
            this.winHeight = window.innerHeight
        },
		onConfirmationClose(answer) {
			this.message = {}
			this.confirmation = false			
            if(answer == 'yes') {
                this.endDialog()
            }
		},
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    mounted() {
        //console.log('dialog report mounted')
        this.editData()
        this.dialog = true
    },
    beforeDestroy() {
        //console.log('destroying dialog report')
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
    },
}
</script>
<style scoped>
.v-data-table td {
  border: none !important;
}

.v-data-table >>> tbody tr:hover {
  background: transparent !important;
}

.right-aligned >>> input {
    text-align: end;
}

</style>